<template>
  <div v-if="event" :idfoevent="event.idfoevent.toString()">
    <div v-if="isDebug">
      EVENT<br />
      event.idfoevent {{ event.idfoevent }} <br />
      event.internalorder {{ event.internalorder }}
    </div>
    <v-layout coupon-event
              :class="[{'outright': event && event.markets && event.markets[0] && (event.markets[0].isoutright || !event.ismatch) },
                        {'threeselections': threeselections},
                        {'big3-event': isbig3coupon},
                        {'selections-three-plus': event.markets && event.markets[0].selections.length > 3 || event.markets[0].isoutright},
                        {'selections-nine-plus': event.markets && event.markets[0].selections.length > 9},
                        {'twoselections': twoselections && (event.markets && event.markets[0].selections.length < 3 && !event.markets[0].isoutright)},
                        {'coupon-threeselections': (event.markets && event.markets[0].selections.length === 3 && !event.markets[0].isoutright)}, event.markets[0].idfosporttype]">
      <v-flex class="names participants" v-if="awayParticipantName && homeParticipantName &&
        (!event.markets || (event.markets[0] && event.markets[0].selections.length <= 3 && !event.markets[0].ismainoutright && !event.markets[0].isoutright))">
        <div v-if="!isbig3coupon" class="event-info" :class='{ clickable: event.noofmarkets > 0 }' @click.stop="goToEvent(event)">
          <div class="eventTitle home">
            <span class="name">{{ homeParticipantName }}</span>
            <span v-if="event.homepitchername" class="pitcher-name"><p>{{ event.homepitchername | lowercase }} </p></span>
          </div>
          <div class="eventTitle away">
            <span class="name">{{ awayParticipantName }}</span>
            <span v-if="event.awaypitchername" class="pitcher-name"><p>{{ event.awaypitchername | lowercase }}</p></span>
          </div>
        </div>
        <div v-else class="event-info" :class='{ clickable: event.noofmarkets > 0 }' @click.stop="goToEvent(event)">
          <div class="eventTitle away">
            <span class="name">{{ awayParticipantName }}</span>
            <span v-if="event.awaypitchername" class="pitcher-name"><p>{{ event.awaypitchername | lowercase }}</p></span>
          </div>
          <div class="eventTitle home">
            <span class="name">{{ homeParticipantName }}</span>
            <span v-if="event.homepitchername" class="pitcher-name"><p>{{ event.homepitchername | lowercase }}</p></span>
          </div>
        </div>
      </v-flex>

      <div class="market">
        <!-- Display name for 'Outright' coupon, like 'NBA Winner', 'NBA - First pick of draft' -->
        <div v-if="event.markets[0].isoutright" class="outright outright-event-name">{{ event.externaldescription }}</div>
        <markets class="markets-container"
                 :markets="isbig3coupon ? event.markets : [event.markets[0]]"
                 :event="event"
                 :iscoupondisplay="!!event.participantname_away"
                 :diplayOnPage="'coupon'"
                 :isbig3coupon="isbig3coupon"
                 :couponname="couponname"></markets>
        <div class="more-markets" :class='{ clickable: event.noofmarkets > 0 }' @click.stop="goToEvent(event)"
             v-if="!event.markets[0].isoutright && !mobileBigAndBelow && !hasMarketWithThreePlusSelections && (event.noofmarkets && event.noofmarkets > 0) && ['GOLF', 'MOTORSPORT'].indexOf(event.markets[0].idfosporttype) === -1"
             ><span>{{ $t('Sports.Markets') }}</span><span class="pd-icon pd-icon-chevron-right"></span></div>
      </div>
    </v-layout>

    <!-- Single coupon footer -->
    <section  class="single-coupon-footer" :class="{'live-streaming': isLiveStreamAvailable}">
      <!-- Display date-time for event-->
      <div class="time">
        <span v-if="isDateToday(event.tsstart)">Today {{ (event.tsstart) | moment(dateFormats.longTime)}}</span>
        <span v-if="isDateTomorrow(event.tsstart)">Tomorrow {{ (event.tsstart) | moment(dateFormats.longTime)}}</span>
        <span v-if="!isDateToday(event.tsstart) && !isDateTomorrow(event.tsstart)">{{ event.tsstart | moment(dateFormats.longDateTime) }} </span>
      </div>    
      <!-- Link for more markets in coupon -->
      <div class="more-markets" :class='{ clickable: event.noofmarkets > 0 }' @click.stop="goToEvent(event)"
           v-if="(mobileBigAndBelow || event.markets[0].isoutright)  && !hasMarketWithThreePlusSelections && (event.noofmarkets && event.noofmarkets > 0) && ['GOLF', 'MOTORSPORT'].indexOf(event.markets[0].idfosporttype) === -1"
           ><span>{{ $t('Sports.Markets') }}</span><span class="pd-icon pd-icon-chevron-right"></span></div>
    </section>
  </div>
</template>
<script>
  import markets from '@/components/sports/bettingoffer/markets'
  import store from '@/store'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Screen from '@/components/mixins/Screen'

  export default {
    name: 'couponEvent',

    props: [
      'event',
      'twoselections',
      'threeselections',
      'isbig3coupon',
      'couponname'
    ],

    components: {
      markets
    },

    mixins: [
      BettingOffer,
      Screen
    ],

    computed: {
      hasMarketWithThreePlusSelections () {
        let key = false
        if (this.event && this.event.markets && this.event.markets.length) {
          this.event.markets.forEach(market => {
            if (market && market.selections && market.selections.length && market.selections.length > 3) {
              key = true
            }
          })
        }
        return key
      },
      awayParticipantName () {
        return this.event.participantname_away ||
          (this.event.markets && this.event.markets[0] && this.event.markets[0].selections &&
            this.event.markets[0].selections.find(sel => sel.hadvalue === 'A') &&
            this.event.markets[0].selections.find(sel => sel.hadvalue === 'A').name) || ''
      },
      homeParticipantName () {
        return this.event.participantname_home ||
          (this.event.markets && this.event.markets[0] && this.event.markets[0].selections &&
            this.event.markets[0].selections.find(sel => sel.hadvalue === 'H') &&
            this.event.markets[0].selections.find(sel => sel.hadvalue === 'H').name) || ''
      },
      liveStreams () {
        return store.getters['livebettingState/liveStreams']
      },
      isLiveStreamAvailable () {
        return this.liveStreams && this.liveStreams.find(ls => ls.idfoevent === this.event.idfoevent)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  @import "~@/css/config"
  .coupon-event
    &.outright
      border-top none
  .coupon-event
    background white
    //border-top 1px solid #CFD6DB
    user-select none
    padding 12px 5px 0px 9px
    align-items: center
    justify-content space-between
    position relative
    .names.participants
      min-width 0
      flex unset
      .eventTitle
        font-size 14px
        color #445058
        overflow hidden
        text-overflow ellipsis
        height 40px
        margin 2px 0
        line-height 35px
        white-space nowrap
        .pitcher-name
          font-size 12px
          text-transform capitalize
          color #1e1e47
          line-height 0
          display block
        &:last-child
          margin-bottom: 0
    .market
      .markets-container
        margin-bottom 0
    .markets.multiple
      .market
        &.money
          .selectionprice
            line-height 18px
            font-weight bold !important
            // height 40px
            position relative
            // top 10px

    &.twoselections
      .market
        .selections
          padding 0
          display inline-block
          .selection
            margin 2px
            span
              //height 40px
              border-radius 5px
              line-height 12px
            &.U,
            &.O
              .selection-wapper
                padding 0
                .currenthandicap,
                .selectionprice
                  line-height 20px
            &.U,
            &.A
              margin-bottom 4px
            &.O,
            &.A
              margin-top 4px
            &.H,
            &.A
              .selection-wapper
                padding 11px 9px
        &.suspended
          .selection-wapper
            padding 11px 9px

    &.threeselections
      .names.participants
        .eventTitle
          height 35px
          margin 0
          line-height 25px
          white-space nowrap
          display table
          width: 100%
          table-layout: fixed
          .name
            display table-cell
            vertical-align middle
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          .pitcher-name
            display table-row
            vertical-align middle
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            p
              overflow: hidden
              text-overflow: ellipsis
              white-space: nowrap
              width: 100%
              height: 10px
              line-height: 8px
    &.selections-three-plus
      .market
        width 100%
    &.big3-event
      .names.participants
        min-width initial
        @media mobile-big-and-below
          min-width 0
          // flex 5
        .eventTitle
          overflow initial
          text-overflow initial
          white-space normal
          display: table
          line-height: initial
          @media mobile-big-and-below
            text-overflow ellipsis
            white-space nowrap 
            overflow hidden
            max-width 100%
            display flex
            // align-items center
            flex-direction column
          .name
            display table-cell
            vertical-align middle
            @media mobile-big-and-below
              display block
              text-overflow ellipsis
              white-space nowrap 
              overflow hidden
              max-width 100%
          .pitcher-name
            display table-row
            line-height 8px

      .market
        white-space nowrap

  /*Coupon footer*/
  .single-coupon-footer
    display flex
    justify-content space-between
    margin-bottom 0px
    font-size 10px
    font-weight normal
    user-select none
    padding 7px 11px 12px 8px
    align-items: center
    color #818e95
    section
      margin-bottom 0
      .time,
      .time-period
        padding-bottom 0
        color #818e95
        line-height 40px
    .more-markets
      // padding-right 10px
      padding-bottom 0
      cursor pointer
      white-space nowrap
      color #06283b !important
      font-size 10px
      font-weight normal
      display flex
      align-items center
      justify-content center      
      span 
        line-height normal

    /*ends: Coupon footer*/

   /* active selection */
   .active .value, .active .names, .active .selection-wapper
    background-color #0fb3a1  !important
    color #fff !important
    border-radius: 3px

  .active .selection-wapper
    border 0px !important

  .active .selectionprice
    color #fff
  /*ends: active selection */

  .live-coupon
    .market
      .markets-container
        margin-bottom 0
    .markets.multiple
      .market
        &.money
          .selectionprice
            line-height 18px
            height 40px
            position relative
            top 10px
            &.suspended
              // top 0

  .outright
    padding 15px 0 10px 15px
  .selections-nine-plus
    padding: 0px
    border-bottom-right-radius: 5px
    border-bottom-left-radius: 5px
    .outright-event-name
      padding 15px 0 10px 15px
  .outright-event-name
    padding 0 0 5px 0
    font-weight bold
    font-size 14px

  .browser-internet-explorer.browser-version-11
    .coupon-event.outright.selections-three-plus.twoselections
      .market
        width: 100%

  .url-sports.url-navigation .single-coupon-footer
    padding-top 0px
.browser-safari.browser-version-12,
.browser-chrome.browser-version-71.os-macos
  .single-coupon-footer
    .more-markets
      span 
        line-height normal 
        margin-top 1px
.clickable
  cursor pointer

.live-stream.prematch
  display inline
  align-items center
  color #0d7fe1 !important
  text-transform uppercase
  font-size 10px
  margin-left 5px
  padding-left 5px
  border-left 1px solid #cfd6db
  cursor pointer
  span
    color #0d7fe1 !important
  .icon
    color #0d7fe1
    border 1px solid #0d7fe1
    border-radius 50%
    font-size 13px
    margin-right 3px
    margin-bottom 2px
    @media mobile-big-and-below
      font-size 13px
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/couponEvent.vue